import React from 'react'
import icon39 from '../../../assets/images/icon-39.png'
import icon7 from '../../../assets/images/icon-7.png'
import icon43 from '../../../assets/images/icon-44.png'
import icon4 from '../../../assets/images/icon-4.png'
import { config } from '../config'
import { Link } from 'react-router-dom'

const CourseDetailOverview = ({courseData}) => {
  
    return (
        <section className="course-details">
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                        <div className="content-box">
                            <div className="sec-title">
                                <h2>Course details</h2>
                            </div>
                            <div className="text">
                                <p dangerouslySetInnerHTML={{__html : courseData?.description}}/>
                            </div>
                            <div className="btn-box">
                                <Link to={`${config.appUrl}book-a-lesson`} 
                                    state={{courseData : courseData}}
                                    className="theme-btn btn-five">
                                    Book Now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 inner-column">
                        <div className="inner-box">
                            <div className="upper-box">
                                <div className="price-box">
                                    <h6>From</h6>
                                    <h2>
                                        <span>£</span>{courseData.price}
                                    </h2>
                                    {/* <h5>Per Person</h5> */}
                                </div>
                                {/* <div className="inner">
                                    <h4>Excellent</h4>
                                    <ul className="rating clearfix">
                                        <li>
                                            <i className="bi bi-star-fill " />
                                        </li>
                                        <li>
                                            <i className="bi bi-star-fill " />
                                        </li>
                                        <li>
                                            <i className="bi bi-star-fill " />
                                        </li>
                                        <li>
                                            <i className="bi bi-star-fill " />
                                        </li>
                                        <li>
                                            <i className="bi bi-star" />
                                        </li>
                                    </ul>
                                    <p>Trust Score 4.5 (Based on 1,200 reviews)</p>
                                    <div className="feedback">
                                        <h6>
                                            <a href='#'>Read Feedback</a>
                                        </h6>
                                    </div>
                                </div> */}
                            </div>
                            <div className="lower-box">
                                <div className="border-one" />
                                <div className="border-two" />
                                <div className="row clearfix">
                                    <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                        <div className="single-item">
                                            <div className="icon-box">
                                                <img src={icon39} alt="" />
                                            </div>
                                            <h6>Theory Session</h6>
                                            <span>{courseData.theory} Hours</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                        <div className="single-item">
                                        <div className="icon-box bg-light rounded-circle">
                                                <img src={icon7} alt="" />
                                            </div>
                                            <h6>Practical Session</h6>
                                            <span>{courseData.practical} Hours</span>
                                        </div>
                                    </div> 
                                    <div className="col-12 single-column">
                                        <div className="single-item">
                                            <div className="icon-box">
                                                <img src={icon4} alt="" />
                                            </div>
                                            <h6>Certificate</h6>
                                            <span>Course Completion</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CourseDetailOverview